const T_PREFIX = "auth";

export const passwordUpdatePopupTrns = {
  title: `${T_PREFIX}.password-update-popup.title`,
  updatePasswordButton: `${T_PREFIX}.password-update-popup.update-password-btn`,
};
